import { type ResolvedProps } from "@/app.types";
import { type FarmSettingsTo } from "@/generated/api/agroevidence";
import Localization, {
  LANGUAGES,
} from "@/shared/services/Localization.service";
import LocalStorage from "@/shared/services/LocalStorage.service";

import { type UserType } from "./services/menuItems";

import { type NavbarNgProps } from "./navbar.types";

const buildNgProps = (resolved: ResolvedProps): NavbarNgProps => {
  const user = LocalStorage.loadFromLocalStorage<UserType>("user");

  if (!user) {
    throw new Error("buildNgProps called without an authenticated user");
  }

  return {
    isAdmin: resolved.farm.isAdmin,
    farm: resolved.farm,
    farms: resolved.farms,
    farmSettings: LocalStorage.loadFromLocalStorage<FarmSettingsTo>(
      "farmSettings",
    ) ?? {
      eagriSettingsEnabled: false,
      shpSettingsEnabled: false,
    },
    langId: Localization.getLang(),
    langs: LANGUAGES,
    user,
  };
};

export { buildNgProps };
